<input [disabled]="disabled" [style.background]="color" [colorPicker]="color" [cpCmykEnabled]="true" [cpAlphaChannel]="'always'"
       [cpOutputFormat]="'hsla'" (cpCmykColorChange)="cmykValue=$event"
       (colorPickerChange)="cmykColor=onChangeColorCmyk($event);color=$event" (colorPickerClose)="saveField()" class="color-picker"
       (colorPickerCancel)="resetColorValue(true)"
       [cpCancelButton]="true"
       cpCancelButtonText="{{ 'general.reset' | translate }}"/>
